import type {
  SiteHealthAuditScope,
  SiteHealthAuditStatus,
  SiteHealthCategory,
  SiteHealthEvaluationState,
  SiteHealthFindingEvidence,
  SiteHealthSeverity,
  SiteHealthView,
} from './siteHealth.types'

export const SITE_HEALTH_CATEGORIES: readonly SiteHealthCategory[] = [
  'access',
  'rendering',
  'structure',
  'structured_data',
  'content_extractability',
]
const CATEGORY_LABELS: Record<SiteHealthCategory, string> = {
  access: 'Access',
  rendering: 'Rendering',
  structure: 'Structure',
  structured_data: 'Structured data',
  content_extractability: 'Content extractability',
}

export function isSiteHealthView(value: string): value is SiteHealthView {
  return value === 'overview' || value === 'pages' || value === 'finding-types'
}

export function isActiveSiteHealthAuditStatus(
  status: SiteHealthAuditStatus
): boolean {
  return status === 'pending' || status === 'running'
}

export function scopeLabel(scope: SiteHealthAuditScope): string {
  return scope === 'single_page' ? 'Single page' : 'Site'
}

export function categoryLabel(category: SiteHealthCategory): string {
  return CATEGORY_LABELS[category]
}

export function severityLabel(severity: SiteHealthSeverity): string {
  return severity.charAt(0).toUpperCase() + severity.slice(1)
}

export function evaluationLabel(
  evaluation: SiteHealthEvaluationState | undefined
): string {
  if (evaluation === 'not_evaluated') return 'Not evaluated'

  if (evaluation === 'passed') return 'Passed'

  return 'Finding'
}

export function evidenceText(
  evidence: SiteHealthFindingEvidence,
  representation: 'raw' | 'rendered'
): string | null {
  const direct =
    representation === 'raw' ? evidence.rawText : evidence.renderedText
  const fallback = representation === 'raw' ? evidence.raw : evidence.rendered

  if (typeof direct === 'string') return direct

  if (typeof fallback === 'string') return fallback

  return null
}

export function supportArticleUrl(
  docsBaseUrl: string,
  supportArticleSlug: string | null | undefined
): string | null {
  if (!docsBaseUrl || !supportArticleSlug) return null

  return `${docsBaseUrl.replace(/\/+$/, '')}/${supportArticleSlug.replace(/^\/+/, '')}`
}
